export const CARD_HIDE = 'CARD_HIDE';
export const RATE_ME_RATED = 'RATE_ME_RATED';
export const RATE_ME_DELAY = 'RATE_ME_DELAY';
export const QUESTIONNAIRES_DELAY = 'QUESTIONNAIRES_DELAY';
export const PAIN_GUIDE_HIDE_ENGLISH = 'PAIN_GUIDE_HIDE_ENGLISH';
export const PAIN_GUIDE_IGNORE_ENGLISH = 'PAIN_GUIDE_IGNORE_ENGLISH';
export const PAIN_GUIDE_INTRODUCED = 'PAIN_GUIDE_INTRODUCED';
export const FEED_CARD_RE_ORDER_CARDS = 'RE_0RDER_CARDS';
export const FEED_CARD_TOGGLE_CARD_COLLAPSE = 'FEED_CARD_TOGGLE_CARD_COLLAPSE';
